import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/admin/audit-trails')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/admin/audit-trails']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
